import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'pim-collapsible-content',
    templateUrl: './collapsible-content.component.html',
    styleUrls: ['./collapsible-content.component.sass'],
    standalone: false
})
export class CollapsibleContentComponent {
	// This sets the class "collapsed" on the host-element if collapsed is true
	@Input()
	@HostBinding('class.collapsed')
	collapsed: boolean = false;

	@Input()
	headerClass: string = '';

	toggle(): void {
		this.collapsed = !this.collapsed;
	}
}
